module.exports = __webpack_public_path__ + "static/icon-b3cc7b74791f0c76dd6a10a86d6aeced.png";